var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var LedgerAccountCategoryOrderModel;
  return LedgerAccountCategoryOrderModel = (function(_super) {

    __extends(LedgerAccountCategoryOrderModel, _super);

    function LedgerAccountCategoryOrderModel() {
      LedgerAccountCategoryOrderModel.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountCategoryOrderModel.prototype.defaults = function() {
      return {
        id: null,
        clientId: null,
        categoryId: null,
        type: null
      };
    };

    return LedgerAccountCategoryOrderModel;

  })(BaseModel);
});
